import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { AppStandardButton } from "../AppButtons";

export default function AlertDialog({
  open,
  onClose,
  onCancel,
  onConfirm,
  title,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{title}</DialogTitle>

        <DialogActions>
          <AppStandardButton variant="outlined" onClick={onCancel}>
            <p className="text-black normal-case">Cancel</p>
          </AppStandardButton>
          <AppStandardButton onClick={onConfirm} autoFocus>
            <p className="normal-case">Add Driver</p>
          </AppStandardButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
